export var AI_PLATFORM = /* @__PURE__ */ ((AI_PLATFORM2) => {
  AI_PLATFORM2["ANTHROPIC"] = "anthropic";
  AI_PLATFORM2["OPENAI"] = "openai";
  AI_PLATFORM2["VOYAGE"] = "voyage";
  return AI_PLATFORM2;
})(AI_PLATFORM || {});
export var PROMPT_ROLE = /* @__PURE__ */ ((PROMPT_ROLE2) => {
  PROMPT_ROLE2["ASSISTANT"] = "assistant";
  PROMPT_ROLE2["USER"] = "user";
  return PROMPT_ROLE2;
})(PROMPT_ROLE || {});
